import PropTypes from "prop-types"
import { FormProvider, useForm } from "react-hook-form"
import { useMutation, useQueryClient } from "react-query"
import { useHistory } from "react-router-dom"
import * as yup from "yup"
import { createDoc } from "~/actions/docs"
import Input from "~/components/ReactHookForms/Input"
import SharedDialog from "~/dialogs/SharedDialog"
import useYupValidationResolver from "~/hooks/useYupValidationResolver"

const createDocSchema = yup.object().shape({
  name: yup.string().required(),
})

const AddDocDialog = ({ open, closeDialog, refetchDocs }) => {
  const createDocMutation = useMutation(createDoc)
  const history = useHistory()
  const queryClient = useQueryClient()

  const resolver = useYupValidationResolver(createDocSchema)

  const methods = useForm({
    resolver,
  })

  const onSubmitHandler = (data) => {
    createDocMutation
      .mutateAsync(data)
      .then((res) => {
        methods.reset()
        history.push(`/documents/${res.id}/details`)
        queryClient.invalidateQueries("docs")
      })
      .catch((err) => {
        console.error(err)
      })
  }
  return (
    <SharedDialog
      isOpen={open}
      onClose={() => {
        closeDialog()
        methods?.reset()
      }}
      action={methods?.handleSubmit(onSubmitHandler)}
    >
      <div className="aspect-video">
        <h2>Add Doc</h2>
        <p>Create new doc</p>
        <FormProvider {...methods}>
          <Input
            label="Doc Name"
            id="name"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                methods.handleSubmit(onSubmitHandler)()
              }
            }}
          />
        </FormProvider>
      </div>
    </SharedDialog>
  )
}

AddDocDialog.propTypes = {
  open: PropTypes.bool,
  closeDialog: PropTypes.func,
  refetchDocs: PropTypes.func,
}

export default AddDocDialog
